import { IoNetIconLight } from "@/components/Icons/IoNetIconLight";
import { Tool } from "@/types";

export const ToolLightLogo = ({ tool }: { tool: Tool }) => {
  return (
    <div className="flex items-center gap-2">
      <IoNetIconLight className="h-[12px] w-auto flex-shrink-0 text-foreground" />
      <div className="h-4 w-px bg-gray-dark-2200 opacity-30" />
      {tool.logoLight && (
        <tool.logoLight className="h-[12px] w-[12px] min-w-[12px] md:h-4 md:w-4" />
      )}
      {tool.icon && (
        <tool.icon
          className="flex h-[12px] items-start md:h-[12px] md:max-w-max"
          inheritColor={true}
        />
      )}
    </div>
  );
};
